<template>
  <div class="redirect-modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content">
        <h1>Weiterleiten</h1>
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="url-inputs">
          <label for="success-url" style="margin-right: 15px"
            >Weiterleiten nach</label
          >
          <input
            type="text"
            style="font-size: 18px; width: 300px; color: black"
            name="success-url"
            v-model="task.props.redirect"
            placeholder="https://codelos.io/success"
          />
        </div>
        <button class="btn-black" @click="close">Speichern</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Redirect',
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  props: {
    task: Object,
  },
};
</script>
<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.redirect-modal-wrapper .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.redirect-modal-wrapper .modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  position: fixed;
  padding: 25px;
  width: 650px;
  /* min-height: 300px; */
  height: fit-content;
  left: 50%;
  transform: translateX(-50%);
  top: 1%;
  text-align: left;
  -webkit-font-smoothing: antialiased;
}

.redirect-modal-wrapper .content {
  text-align: center;
  font-family: 'Open Sans', open-sans, sans-serif;
}
/* Style that has no refference*/
.redirect-modal-wrapper .html {
  margin-top: -100px;
  margin-bottom: 100px;
  margin-right: 14%;
  height: 250px;
}

.redirect-modal-wrapper .content > h1 {
  margin-top: 0px;
  color: #333c4e;
  font-weight: 300;
}

.redirect-modal-wrapper .pull-right {
  float: right;
}

.redirect-modal-wrapper button.pull-right {
  margin-right: 0px;
}

.redirect-modal-wrapper .modal .btn-close {
  margin-top: -60px;
  margin-right: -10px;
}

.redirect-modal-wrapper .btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 0;
  margin-top: 25px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.redirect-modal-wrapper .btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}

.redirect-modal-wrapper label {
  float: left;
}
.redirect-modal-wrapper .url-inputs {
  text-align: center;
  min-height: 120px;
  padding-top: 10px;
}

.redirect-modal-wrapper .url-inputs label {
  line-height: 30px;
}
</style>
